import React, { useEffect, useState } from 'react'
import SettingsStore from '../../flux/settings/SettingsStore'
import { showInfo, hideInfo } from '../../flux/settings/SettingsActions'
import NavbarComponent from './Navbar'
import { createBoard } from '../../flux/boards/BoardActions'

/**
 * Business logic which drives the navbar component
 * @returns {JSX.Element} Component which controls the Navbar
 */
function ControlNavbarComponent() {
    const settingsStore = SettingsStore.GetInstance()
    const [isInfoVisible, setIsInfoVisible] = useState(settingsStore.InfoState)

    /**
     * Handles request to create a new board
     */
    function handleCreateBoard() {
        createBoard()
    }

    /**
     * Handles request to show info panel
     */
    function handleInfoVisible() {
        showInfo()
    }

    /**
     * Handles request to hide info panel
     */
    function handleInfoHidden() {
        hideInfo()
    }

    useEffect(() => {
        /**
         * Invoked when the settings store registers a change in state
         */
        function handleSettingsStoreChange() {
            setIsInfoVisible(settingsStore.InfoState)
        }

        settingsStore.addChangeListener(handleSettingsStoreChange)
        return () => {
            settingsStore.removeChangeListener(handleSettingsStoreChange)
        }
    }, [settingsStore])

    return (
        <NavbarComponent
            onCreateBoard={handleCreateBoard}
            onInfoVisible={handleInfoVisible}
            onInfoHidden={handleInfoHidden}
            isInfoVisible={isInfoVisible}
        />
    )
}

export default ControlNavbarComponent
